<template>
    <div id="routes">
        <!-- <pre>
            {{ provider_routes }}
        </pre> -->

        <div v-for="route in provider_routes.children">
            {<!--
            --><br><!--
                -->&nbsp;&nbsp;&nbsp;
                "name":

                <span v-if="route.path != '/'">"{{ route.path }}"</span>
                <span v-if="route.name">"{{ route.name }}"</span><!--
                -->,
                <span v-if="route.children">
                    <br>
                    &nbsp;&nbsp;&nbsp;
                    "action_names": [
                        <div v-for="children in route.children">
                            <p style="padding-left: 18px;margin-bottom: 0;"
                                v-if="children.name"
                            >
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                "{{ children.name }}",
                            </p>
                            <p v-if="children.children"
                                v-for="sub_children in children.children"
                                style="padding-left: 18px;margin-bottom: 0;"
                                >
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                "{{ sub_children.name }}",
                            </p>
                            <p v-else>
                            </p>
                        </div>

                    &nbsp;&nbsp;&nbsp;
                    ],<!--
                --></span><!--
                --><br>
            },
        </div>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
        }
    },
    computed: {
        provider_routes: function() {
            return _.find(this.$router.options.routes, function(route) {
                return route.path == '/provider'
            });
        },
    },
    mounted: function() {
        var that = this;
        // console.log('///////////////that.$router.options.routes///////////////');
        // console.log(that.$router.options.routes);
    }
}
</script>
